<template>
  <div>
    <Banner bgsrc="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/about/about_banner.jpg">
      <span class="w-banner_text" style="color: #ffffff;">{{ this.$t('about.XY') }}</span>
    </Banner>
    <div class="w-about_us">
      <div class="w-us_title">
        <XYTitle xText="ABOUT US"></XYTitle>
      </div>
      <div class="w-us_content">
        <div class="w-content_left">
          <!-- <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class=" w-left_title w-moduleBanner_text">关于我们</div>
          </Animation> -->
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <p class="w-paragraph_text w-left_text">
              {{ $t('about.aboutUsText1') }}
            </p>
          </Animation>
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <p class="w-paragraph_text w-left_text w-left_text2">
              {{ $t('about.aboutUsText2') }}
            </p>
          </Animation>
        </div>
        <div class="w-content_right">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/about/about_img_1.png" alt="#">
          </Animation>
        </div>
      </div>
    </div>
    <div class="w-about_reasons">
      <XYTitle xText="REASONS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-moduleBanner_text w-reasons_title">
          {{ this.$t('about.reasonsTitle') }}
        </div>
      </Animation>
      <div class="w-reasons_content">
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <video src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/Company%20Video.mp4" controls class="w-content_video"></video>
        </Animation>
        <div class="w-content_box">
          <template v-for="(item,index) in reasonsList">
            <Animation :key="index" defaultClass="w-transform_top" animationClass="w-transform_show">
              <div class="w-box_item">
                <i :class="'iconfont '+item.icon"></i>
                <span class="w-smallTitle_text">{{ item.title }}</span>
                <span class="w-paragraph_text">{{ item.text }}</span>
              </div>
            </Animation>
          </template>
        </div>
      </div>
    </div>
    <!-- <div class="w-about_number">
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-number_group">
          <div>
            <div>
              <NumberLoader :targetNumber="20" :duration="500" :numClass="'w-homeNumber_text w_number'">
                <span class="w_suspension w_sign">+</span>
              </NumberLoader>
            </div>
            <span class="w-nonParagraph_text w_text1">{{ this.$t('home.productSeries') }}</span>
          </div>
          <div>
            <div>
              <NumberLoader :targetNumber="20" :duration="500" :numClass="'w-homeNumber_text w_number'">
                <span class="w_suspension w_year">{{ this.$t('home.year') }}s</span>
              </NumberLoader>
            </div>
            <span class="w-nonParagraph_text w_text1">{{ this.$t('home.technicalExperience') }}</span>
          </div>
          <div>
            <div>
              <NumberLoader :targetNumber="2" :duration="100" :numClass="'w-homeNumber_text w_number'"></NumberLoader>
            </div>
            <span class="w-nonParagraph_text w_text1">{{ this.$t('home.researchAndDevelopmentCenter') }}</span>
          </div>
          <div>
            <div>
              <NumberLoader :targetNumber="3000" :duration="500" :numClass="'w-homeNumber_text w_number'">
                <span class="w_suspension w_sign">+</span>
              </NumberLoader>
            </div>
            <span class="w-nonParagraph_text w_text1">{{ this.$t('home.cooperativeClient') }}</span>
          </div>
        </div>
      </Animation>
    </div> -->
    <!-- <div class="w-about_team">
      <XYTitle xText="TEAM"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-moduleBanner_text w-team_title">
          {{ this.$t('about.teamTitle') }}
        </div>
      </Animation>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-team_img"></div>
      </Animation>
      <div class="w-team_content">
        <template v-for="(item,index) in teamList">
          <Animation :key="index" defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-content_item">
              <span class="w-smallTitle_text">{{ item.title }}</span>
              <span class="w-paragraph_text">{{ item.text }}</span>
            </div>
          </Animation>
        </template>
      </div>
    </div> -->
    <!-- <div class="w-home_partner">
      <XYTitle xText="PARTNERS"></XYTitle>
      <Animation defaultClass="w-transform_top w-partner_box" animationClass="w-transform_show">
        <div class="w-moduleBanner_text">{{ this.$t('home.partnersTitle') }}</div>
        <div class="w-paragraph_text">{{ this.$t('home.partnerText') }}</div>
      </Animation>
      <div class="wpartner_list">
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner1.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner2.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner3.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner4.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner5.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner6.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner7.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner8.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner9.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner10.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner11.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner12.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner13.png" alt="" />
        </Animation>
        <Animation defaultClass="w-transform_top item" animationClass="w-transform_show">
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_partner14.png" alt="" />
        </Animation>
      </div>
    </div> -->
    <div class="w-about_dream">
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-banner_text w-dream_text1">
          <span class="w-text_span">
            {{ this.$t('about.dreamText1') }}
            <span class="w-text_rightTop">+</span>
          </span>
        </div>
      </Animation>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-nonParagraph_text w-dream_text2">{{ this.$t('about.dreamText2') }}</div>
      </Animation>
    </div>
    <!-- <div class="w-about_Honor">
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-moduleBanner_text w-honor_Title">
          {{ this.$t('about.honorTitle') }}
        </div>
      </Animation>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div>
          <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/about/about_img_3.png" alt="#" style="width:100%;height: auto;">
        </div>
      </Animation>
    </div> -->
    <Footer />
  </div>
</template>

<script>
import Banner from '@/components/Banner'
import XYTitle from '@/components/XYTitle.vue'
import Animation from '@/components/Animation.vue'
import NumberLoader from '@/components/NumberLoader.vue'
import Footer from '@/components/Footer.vue'
export default {
  props: {

  },
  data () {
    return {
      reasonsList: [
        {
          icon: 'icon-about_icon_reason1',
          title: this.$t('about.reasonsItemTitle1'),
          text: this.$t('about.reasonsItemText1')
        },
        {
          icon: 'icon-about_icon_reason2',
          title: this.$t('about.reasonsItemTitle2'),
          text: this.$t('about.reasonsItemText2')
        },
        {
          icon: 'icon-about_icon_reason3',
          title: this.$t('about.reasonsItemTitle3'),
          text: this.$t('about.reasonsItemText3')
        },
        {
          icon: 'icon-about_icon_reason4',
          title: this.$t('about.reasonsItemTitle4'),
          text: this.$t('about.reasonsItemText4')
        }
      ],
      teamList: [
        {
          title: this.$t('about.teamItemTitle1'),
          text: this.$t('about.teamItemText1')
        },
        {
          title: this.$t('about.teamItemTitle2'),
          text: this.$t('about.teamItemText2')
        },
        {
          title: this.$t('about.teamItemTitle3'),
          text: this.$t('about.teamItemText3')
        },
        {
          title: this.$t('about.teamItemTitle4'),
          text: this.$t('about.teamItemText4')
        },
        {
          title: this.$t('about.teamItemTitle5'),
          text: this.$t('about.teamItemText5')
        }
      ]
    };
  },
  methods: {

  },
  components: {
    Banner, XYTitle, Animation, NumberLoader, Footer
  },
};
</script>

<style scoped lang="scss">

</style>
